import { render, staticRenderFns } from "./ContentColumn.vue?vue&type=template&id=6ffc0a8b&"
import script from "./ContentColumn.vue?vue&type=script&lang=js&"
export * from "./ContentColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports